import {
    fetchPaginatedList,
    fetchPaginatedListSuccess,
    fromPageToken,
    InputSelectSearchEvent,
} from '@interacta-shared/util';
import { map, Observable } from 'rxjs';
import {
    SearchPaginatedFilters,
    SearchPaginatedParams,
} from './search-paginated.model';

export const fetchNextSearchPaginated = <T, F>({
    inputFilters,
    currentFilters,
    list,
    fetchList,
    pageSize,
}: SearchPaginatedParams<T, F>): Observable<void> => {
    list.update((list) =>
        fetchPaginatedList(list, inputFilters.nextPageToken ?? undefined),
    );

    const { filters, paginatedFilters } = fromInputSelectSearchEvent(
        inputFilters,
        currentFilters,
        pageSize,
    );

    return fetchList(filters, paginatedFilters).pipe(
        map((nextList) =>
            list.update((currList) =>
                fetchPaginatedListSuccess(currList, nextList),
            ),
        ),
    );
};

export const fromInputSelectSearchEvent = <T>(
    inputFilters: InputSelectSearchEvent,
    currentFilters: T,
    pageSize = 10,
): {
    filters: T;
    paginatedFilters: SearchPaginatedFilters;
} => ({
    filters: {
        ...currentFilters,
        search: inputFilters.text ?? '',
    },
    paginatedFilters: {
        pageToken: fromPageToken(inputFilters.nextPageToken ?? undefined),
        pageSize,
    },
});
